import useNetwork from './network';
import { IProviderModel } from './models/providerModel';
import { IUserModel } from './models/userModel';

export const updateUser = async (lang: string, id: string, details: IUserModel) => {
    const { updateUser } = useNetwork();
    const result = await updateUser(lang, id, details);

    if (result.status === 200) {
        return (await result.json()) as IProviderModel[];
    }
};
